import { MonetizationType } from '@/@types/graphql-types';
import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';

export function useProviderBuyboxExpTags() {
	const { activeVariantWithControlGroup, experimentInfo } = useExperiment('EXP_PROVIDER_BUYBOX');
	const { country } = storeToRefs(useLanguageStore());

	function setProviderBuyboxExpTag(
		url: ClickoutUrl,
		placement: 'ro' | 'ft',
		shortName: string = '',
		monetizationType?: MonetizationType
	) {
		if (!activeVariantWithControlGroup.value) return url;
		if (!['atp', 'itu', 'amp', 'prv', 'amz', 'hlu'].includes(shortName)) return url;
		if (
			placement === 'ro' &&
			monetizationType &&
			![MonetizationType.Flatrate, MonetizationType.Free].includes(monetizationType)
		)
			return url;

		const tag = getExperimentAffiliateTag({
			affiliationShortId: experimentInfo.value.affiliationShortId as string,
			variant: activeVariantWithControlGroup.value,
			country: country.value,
			placement,
			providerShortName: shortName,
		});

		url.set('uct_ctag', tag);
		return url;
	}

	return { setProviderBuyboxExpTag };
}
